const CoachIcon = (props: any) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={16}
		height={16}
		fill="none"
		{...props}
	>
		<mask
			id="a"
			width={16}
			height={16}
			x={0}
			y={0}
			maskUnits="userSpaceOnUse"
			style={{
				maskType: "alpha",
			}}
		>
			<path fill="#D9D9D9" d="M0 0h16v16H0z" />
		</mask>
		<g mask="url(#a)">
			<path
				fill="currentColor"
				d="M2.91 10.226c-.531 0-.982-.186-1.353-.557A1.841 1.841 0 0 1 1 8.317c0-.53.186-.981.557-1.353a1.841 1.841 0 0 1 1.352-.556V5.135c0-.35.125-.65.374-.899.25-.25.549-.374.899-.374H6.09c0-.53.186-.98.557-1.352A1.841 1.841 0 0 1 8 1.953c.53 0 .981.186 1.352.557.371.371.557.822.557 1.352h1.91c.35 0 .649.125.898.374.25.25.374.549.374.899v1.273c.53 0 .981.185 1.352.556.371.372.557.822.557 1.353 0 .53-.186.98-.557 1.352a1.841 1.841 0 0 1-1.352.557v2.545c0 .35-.125.65-.374.9-.25.248-.549.373-.899.373H4.182c-.35 0-.65-.125-.9-.374a1.226 1.226 0 0 1-.373-.899v-2.545Zm3.18-1.273a.92.92 0 0 0 .677-.278.92.92 0 0 0 .278-.676.92.92 0 0 0-.278-.677.92.92 0 0 0-.676-.278.92.92 0 0 0-.676.278.92.92 0 0 0-.279.677c0 .265.093.49.279.676a.92.92 0 0 0 .676.278Zm3.82 0a.92.92 0 0 0 .675-.278.92.92 0 0 0 .279-.676.92.92 0 0 0-.279-.677.92.92 0 0 0-.676-.278.92.92 0 0 0-.676.278.92.92 0 0 0-.278.677c0 .265.092.49.278.676a.92.92 0 0 0 .676.278ZM5.454 11.5h5.09v-1.273h-5.09v1.273ZM4.182 12.77h7.636V5.135H4.182v7.636Z"
			/>
		</g>
	</svg>
);
export default CoachIcon;
